import { useCallback } from 'react';

import { useProducts } from 'contexts/Products';
import VirtualPackField from 'fields/VirtualPackField';
import { useField } from 'formik';

export default function VirtualPack({ disabled }: { disabled?: boolean }) {
  const [, , { setValue }] = useField('productData');
  const [, , { setValue: setPackagedItemQty }] = useField('packagedItemQty');
  const [, , { setValue: setQuantity }] = useField('quantity');

  const {
    state,
    selectors: { selectVirtualPack },
  } = useProducts();

  const handleChange = useCallback(
    (value) => {
      setValue(selectVirtualPack(state.virtualPacks, value) || {});
      setPackagedItemQty('');
      setQuantity('');
    },
    [selectVirtualPack, setPackagedItemQty, setQuantity, setValue, state],
  );

  return (
    <VirtualPackField
      name="packagedItemReference"
      disabled={disabled}
      onChange={handleChange}
      textFieldProps={{
        required: true,
      }}
    />
  );
}
